import React, { Component } from 'react';
import PropTypes from 'prop-types';

class PreviewIframe extends Component {
    iframe = React.createRef();

    componentDidMount() {
        const { body } = this.props;
        if (body) {
            this.fillIframe(body);
        }
    }

    componentDidUpdate() {
        const { body } = this.props;
        if (body) {
            this.fillIframe(body);
        }
    }

    fillIframe = (body) => {
        const fill = () => {
            const document = this.iframe.current.contentDocument;
            document.body.innerHTML = body;
            document.body.style.userSelect = 'none';
            document.body.style.paddingBottom = 10;
            document.body.style.WebkitTransform = 'scale(1)';
            document.addEventListener('scroll', () => {
                document.body.style.WebkitTransform = document.body.style.WebkitTransform ? '' : 'scale(1)';
            });
            const imgElms = document.body.getElementsByTagName('img');
            for (let i = 0; i < imgElms.length; ++i) {
                imgElms[i].style.height = 'initial';
            }
        };
        fill();
        document.getElementById('iframePreview').onload = fill;
    };

    render() {
        const { previewWidth } = this.props;
        return (
            <div style={{ height: '100%' }}>
                <iframe
                    id="iframePreview"
                    ref={this.iframe}
                    title="preview-iframe"
                    width="100%"
                    height="100%"
                    frameBorder="0"
                    className="scrollFix"
                    style={{
                        height: '100%',
                        overflowY: 'scroll',
                        width: previewWidth,
                        margin: '0 auto',
                        display: 'block',
                        WebkitTransform: 'scale(1)',
                    }}
                />
            </div>
        );
    }
}

PreviewIframe.propTypes = {
    previewWidth: PropTypes.string.isRequired,
    body: PropTypes.string.isRequired,
};

export default PreviewIframe;
